var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.12,12.06c2.29-.53,4.43-.99,3.39-2.94C10.37,3.18,12.68,0,16,0s5.64,3.3,2.49,9.12c-1.07,1.96,1.15,2.43,3.39,2.94,1.99,.46,2.12,1.43,2.12,3.11v.83H8c0-2.2-.18-3.41,2.12-3.94ZM0,16H6c-.03-6.54,2.99-3.7,2.99-8.9,0-2.01-1.31-3.1-3-3.1-2.49,0-4.23,2.38-1.87,6.84,.78,1.46-.83,1.81-2.55,2.21-1.49,.34-1.59,1.07-1.59,2.33v.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefer);
export default __webpack_public_path__ + "static/media/refer.d478838911d0ce4e243d96bd41fe8fff.svg";
export { ForwardRef as ReactComponent };